import { Component } from '@angular/core';

/* Dummy component used for transition animation when reloading page using ionic */

@Component({
  select: 'manager-root',
  templateUrl: './root.component.html',
  styles: ['section { width: 100%; height: 100%; }'],
})
export class RootComponent {}
